import { BOBIN_TYPE_REQUEST, CREATE_BOBIN_TYPE, GET_BOBIN_TYPES, UPDATE_BOBIN_TYPE, DELETE_BOBIN_TYPE, BOBIN_TYPE_REQUEST_FAILURE } from '../types';

const initialState = {
  bobinType: [],
  loading: false,
  error: null,
};

const bobinTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOBIN_TYPE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BOBIN_TYPES: {
      return {
        ...state,
        bobinType: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_BOBIN_TYPE:
      return {
        ...state,
        bobinType: [action.payload, ...state.bobinType],
        loading: false,
        error: null
      };
    case UPDATE_BOBIN_TYPE:
      const bobinTypeData = state.bobinType.slice(0);
      const uIndex = bobinTypeData.findIndex((data) => data.id === action.payload.id);
      bobinTypeData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bobinType: [ ...bobinTypeData ],
        loading: false,
        error: null
      };
    case DELETE_BOBIN_TYPE:
      const bobinType = state.bobinType?.slice(0);
      const index = bobinType.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bobinType.splice(index, 1);
      }
      return {
        ...state,
        bobinType: [...bobinType],
        loading: false,
        error: null
      }
    case BOBIN_TYPE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bobinTypeReducer;
